import { LeftBubble } from "../bubble/Bubble";

const TYPING_TIME = 1;
const WAIT_BETWEEN_MESSAGES = 1;

export const isGluedMessage = (lastBatchMessages, glueLen, isGlued, lastBatchMessage) => {
  glueLen = glueLen > 0 ? parseInt(glueLen - 1) : 0;
  if (glueLen < lastBatchMessages.length) {
    isGlued =
      lastBatchMessage === lastBatchMessages[glueLen].key ||
      (isGlued && lastBatchMessage === lastBatchMessages[lastBatchMessages.length - 1].key);
  }
  return isGlued;
};

export const getGlueLen = (lastBatchMessagesLen, isGlued, lastBatchMessage, glueLen, wasGlued, wasLastBatchMessage) => {
  if (
    glueLen === 0 ||
    (!(isGlued && !wasGlued) && lastBatchMessagesLen !== glueLen && wasLastBatchMessage !== lastBatchMessage)
  ) {
    glueLen = lastBatchMessagesLen;
  }
  return glueLen;
};

export const getButtonsDelay = (lastBatchMessagesLen, isGlued, glueLen) => {
  const renderedMessagesCount = isGlued ? lastBatchMessagesLen - glueLen : lastBatchMessagesLen;
  return (parseInt(TYPING_TIME) + 0.5) * renderedMessagesCount;
};

export const getBatchAnimationBehavior = (messages, prevState) => {
  let lastBatchMessages = getMessagesInLastBatch(messages);
  let lastBatchMessagesLen = lastBatchMessages.length;
  let lastBatchMessage = lastBatchMessagesLen > 0 ? lastBatchMessages[lastBatchMessagesLen - 1].key : "";
  let animationBehavior = { lastBatchMessages: lastBatchMessages, lastBatchMessage: lastBatchMessage };
  if (prevState.lastBatchMessage !== lastBatchMessage) {
    let isGlued = isGluedMessage(
      lastBatchMessages,
      prevState.glueLength,
      prevState.isGluedBlock,
      prevState.lastBatchMessage
    );
    let len = getGlueLen(
      lastBatchMessagesLen,
      isGlued,
      lastBatchMessage,
      prevState.glueLength,
      prevState.isGluedBlock,
      prevState.lastBatchMessage
    );
    animationBehavior = {
      ...animationBehavior,
      isGluedBlock: isGlued,
      glueLength: len,
    };
  }
  return animationBehavior;
};

const getMessagesInLastBatch = (messages) => {
  let firstOfBatch = messages.reduce(function(result, item, index) {
    if (item.side === "right") {
      result = index;
    }
    return result;
  }, 1);
  return messages.slice(firstOfBatch + 1, messages.length);
};

export const renderMessagesInLastBatch = (lastBatchMessages, isGluedMessage, glueLength, actions) => {
  return lastBatchMessages.map(function(message, index) {
    let itemIndex = isGluedMessage ? index - glueLength : index;
    let withLogo = lastBatchMessages[index + 1] == null;
    let bubbleAnimationDelay = (TYPING_TIME + WAIT_BETWEEN_MESSAGES) * (itemIndex + 1);
    return LeftBubble(message, withLogo, index, bubbleAnimationDelay, actions, message.alternativeText);
  });
};
